import {
    CANONICAL_VISIBILITY,
    normalizeCanonicalVisibility,
    parseCanonicalVisibility,
} from './visibility';

export const SCHEDULED_ENTITY_VISIBILITY_VALUES = Object.freeze([
    CANONICAL_VISIBILITY.PUBLIC,
    CANONICAL_VISIBILITY.FRIENDS,
    CANONICAL_VISIBILITY.PRIVATE,
]);

export const SCHEDULED_ENTITY_VISIBILITY_VALUE_SET = new Set(SCHEDULED_ENTITY_VISIBILITY_VALUES);

export function normalizeScheduledEntityFormVisibility(value) {
    const normalized = normalizeCanonicalVisibility(value, CANONICAL_VISIBILITY.PRIVATE);
    if (normalized === CANONICAL_VISIBILITY.OWNER_ONLY) {
        return CANONICAL_VISIBILITY.PRIVATE;
    }
    return SCHEDULED_ENTITY_VISIBILITY_VALUE_SET.has(normalized)
        ? normalized
        : CANONICAL_VISIBILITY.PRIVATE;
}

export function resolveScheduledEntityPayloadVisibility(formVisibility, originalVisibility, wasEdited) {
    const normalizedOriginal = parseCanonicalVisibility(originalVisibility);
    if (!wasEdited && normalizedOriginal === CANONICAL_VISIBILITY.OWNER_ONLY) {
        return CANONICAL_VISIBILITY.OWNER_ONLY;
    }
    return normalizeScheduledEntityFormVisibility(formVisibility);
}
